

















































import Vue from 'vue';
import checkout from '@/store/modules/checkout';
import Component from 'vue-class-component';
import CmsBlock from '@/components/Cms/Block.vue';
import Modal from '@/components/UI/Modal.vue';
import ui from '@/store/modules/ui';
import IconTrash from '@/components/SvgIcons/IconTrash.vue';
import gtmhelpers from '@/commons/gtmhelpers';

@Component({
    components: {
        CmsBlock,
        Modal,
        IconTrash,
    },
    provide() {
        return {
            $validator: this.$validator,
        };
    },
})
export default class Coupon extends Vue {
    private loading = false;
    private modalId = 'insertcoupon';

    private get applied(): boolean {
        return checkout.coupon.applied;
    }

    private get coupon(): string {
        return checkout.coupon.coupon;
    }

    private set coupon(val: string) {
        checkout.setCouponCode(val);
    }

    private get couponError(): string {
        return checkout.coupon.error;
    }

      private toggleModal(direction: boolean) {
        direction ? ui.openModal(this.modalId) : ui.closeModal(this.modalId) ;
        this.resetError();
    }

    private async applyCoupon(couponCode: string) {
        checkout.coupon.error = '';
        const valid = await this.$validator.validate('couponcode');
        if (!valid) {
            return;
        }
        this.loading = true;
        const res = await checkout.applyCoupon(couponCode) as unknown;
        this.loading = false;
        if (res) {
            this.toggleModal(false);
            gtmhelpers.trackSuccessApplyCoupon();
        } else {
            gtmhelpers.trackFailedApplyCoupon();
        }
    }

    private async removeCoupon() {
        this.loading = true;
        const res = await checkout.removeCoupon();
        this.loading = false;
    }

    private resetError() {
        this.$validator.reset();
        checkout.coupon.error = '';
    }
}
